import { Fragment } from 'react';

export const MAC_LOGO_URL = '/brand/mac-lockup-approved.jpeg';

export function MacBrand({ className = '' }) {
  return <img loading="lazy" decoding="async" src={MAC_LOGO_URL} alt="MAC — My Assistant CEO" width="1035" height="751"
    className={`inline-block h-auto w-28 object-contain align-middle ${className}`} />;
}

// Keep identifiers, accessible names and stored records textual; render the brand visually.
export function MacText({ children }) {
  if (typeof children !== 'string') return children;
  return children.split(/(\bMAC\b)/gi).map((part, index) =>
    /^MAC$/i.test(part) ? <MacBrand key={index} /> : <Fragment key={index}>{part}</Fragment>);
}

